export default "__VITE_ASSET__DhP8Oato__"